import { Customer } from './Customer';
import { Subscription } from './Subscription';
import { AgGridFilters } from './GlobalInterfaces';

export interface Order {
  id: string;
  orderDate: Date;
  orderNumber: string;
  amount: number;
  voucherCode: string;
  voucherType: string;
  orderState: Status;
  statusDate: Date;
  emailSent: boolean;
  paymentDate: Date;
  subscription: Subscription;
  customer: Customer;
  createdBy: string;
  modifiedBy: string;
  createdDate: Date;
  modifiedDate: Date;
}

export type Status = "COMPLETED" | "NOT_COMPLETED" | "REFUNDED";

export interface OrderGelAllResponseResult {
  totalPages: number;
  "total-elements": number;
  size: number;
  content: Order[];
}

export type RootVoucherGetSingleResponse = Omit<OrderGelAllResponseResult, 'result'> & {
  result: Order[];
};

export interface RootOrderGelAllResponse {
  status: string;
  code: number;
  result: OrderGelAllResponseResult;
}

export interface OrderAdvancedFilters {
  lastName?: string;
  taxCode: string,
  companyName: string,
  vatNumber: string,
  email?: string;
  status?: string;
  voucherCode?: string;
  bookable?: boolean;
  orderDateTo?: string;
  orderDateFrom?: string;
  amountFrom?: number;
  amountTo?: number;
}

export type OrderInputGetAll = AgGridFilters & OrderAdvancedFilters;

export const EMAIL = "EMAIL";
export const SMS = "SMS";
export const CORRELATION_NAME_PBL = "Mobility Voucher:PBL:";
